import { constantes } from '../../constantes';
import { InfoService } from '../../interfaces/infoservice.interface';
import { Service } from '../../interfaces/service.interface';
import { Company } from '../../interfaces/company.interface';
import { environment } from '../../../environments/environment';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-company-list-item',
  templateUrl: './company-list-item.component.html',
  styleUrls: ['./company-list-item.component.scss']
})
export class CompanyListItemComponent implements OnInit {

	@Input() data:Company & Service & InfoService;
	@Input() rubric:string;
	@Output() onLocalize:EventEmitter<Company> = new EventEmitter();
	
	defaultImage:string = 'https://crowdcrafting.org/static/img/placeholder.user.png';
	offset:number = 100;
	visible:boolean = false;
	
  constructor() { }

  ngOnInit() {
		
	}
	
	ngOnChanges(changes:SimpleChanges)
	{
		if(changes.data && this.data){
			let baseurl:string = environment.backBaseUrl;
			let url:string = '';
			if(environment.mockApi){
				url = 'assets/mock/imguploads/' + this.data.logo;
			}
			else url = baseurl + '/imguploads/' + this.data.logo;
			
			if(this.data.logo) this.data.logoUrl = url;
			else this.data.logoUrl = null;
			
		}
		
		//doublon
		if(!constantes.isLazyLoadingEnabled()) this.visible = true;
	}
	
	localize(){
		this.onLocalize.emit(this.data);
	}
	
	
	deferLoad():void
	{
		// console.log('deferLoad() '+this.data.name);
		this.visible = true;
	}

}
